<!-- Popover Button -->
<ng-container *ngIf="showPopoverButton">
  <button #attestationMoveFundsPopover="bs-popover" 
    class="btn"
    [class.btn-link]="isLink"
    [class.btn-primary]="!isLink"
    [attr.aria-label]="buttonText"
    [disabled]="disabled"
    containerClass="custom-popover-width"
    placement="top"
    [popover]="attestationMoveFundsPopoverTemplate"
    [popoverContext]="{
      attestationMoveFundsPopover: attestationMoveFundsPopover
    }"
    [outsideClick]="true"
    (click)="setIsAttestationPopoverView(attestationMoveFundsPopover)">
    {{ buttonText }}
  </button>
</ng-container>

<!-- No Popover needed -->
<ng-container *ngIf="!showPopoverButton">
  <yc-button
    [disabled]="disabled"
    buttonType="submit"
    [primary]="!isLink"
    [link]="isLink"
    [translatedText]="buttonText"
    class="d-flex justify-content-end"
    (onClick)="onSubmit.emit(false)">
  </yc-button> 
</ng-container>


<!-- Attestation / Move Funds Popover Primary -->
<ng-template #attestationMoveFundsPopoverTemplate
  let-attestationMoveFundsPopover="attestationMoveFundsPopover">
  <!-- Move Funds Logic -->
  <ng-container *ngIf="!isAttestationPopoverView">
    <strong class="mb-3 d-block">
      <yc-i18n
        key="AWARDS:hdrMoveFundsQuestion"
        defaultValue="Move Funds?">
      </yc-i18n>
    </strong>
    <span>
      {{ canMoveFundsText }}
    </span>
    <div class="d-flex justify-content-end mb-2 mt-2 align-items-center">
      <!-- No -->
      <yc-button 
        [link]="true"
        langKey="common:textNo"
        defaultText="No"
        class="me-4"
        (onClick)="attestationMoveFundsPopover.hide()">
      </yc-button>
      <!-- Yes - YC Processed -->
      <yc-button *ngIf="isEdit ?
        isUpdatingBudgetFromClientToYc :
        isYcProcessed"
        [primary]="true"
        langKey="common:textYes"
        defaultText="Yes"
        (onClick)="setCurrentPopover(attestationMoveFundsPopover); isAttestationPopoverView = true;">
      </yc-button>

      <!-- Yes - Not YC Processed -->
      <yc-button *ngIf="isEdit ?
        !isUpdatingBudgetFromClientToYc :
        !isYcProcessed"
        [primary]="true"
        langKey="common:textYes"
        defaultText="Yes"
        (onClick)="proceedWithSubmission()">
      </yc-button>
    </div>
  </ng-container>

  <!-- Attestation Logic -->
  <ng-container *ngIf="isAttestationPopoverView">
    <strong class="mb-3 d-block">
      <yc-i18n
        key="AWARDS:hdrAttestationAgreement"
        defaultValue="Attestation Agreement">
      </yc-i18n>
    </strong>
    <span>
      <yc-i18n
        key="common:textAttestationAggreementText2"
        defaultValue="You, on behalf of the organization you represent, attest that the grant you are advising to be issued by the Blackbaud Giving Fund to a charity will be used exclusively for the charity’s exempt purposes and neither the organization you represent nor any other donor affiliated party will receive goods, services, or impermissible benefits (e.g., tuition, memberships, dues, admission to events or goods bought at auction, or anything of more than incidental benefit) as a result of the grant.">
      </yc-i18n>
    </span>
    <div class="d-flex justify-content-end mb-2 mt-2 align-items-center">
      <!-- No -->
      <yc-button 
        [link]="true" 
        class="me-4"
        langKey="common:textNo"
        defaultText="No"
        (onClick)="attestationMoveFundsPopover.hide();">
      </yc-button>
      <!-- Yes -->
      <yc-button 
        [primary]="true"
        langKey="common:textYes"
        defaultText="Yes"
        (onClick)="attestationMoveFundsPopover.hide();
          proceedWithSubmission()">
      </yc-button>
    </div>
  </ng-container>
  
</ng-template>